export default "__VITE_ASSET__D85hu2xN__"